module.exports = __webpack_public_path__ + "img/export_icon.8d9a0b8e.svg";